import { environment } from 'src/environments/environment';
import { CameraCompratorComponent } from './componenets/comprator/products-comprator/camera/camera-comprator/camera-comprator.component';
import { DialogContentInscription } from './componenets/header-sticky/inscription-dialog/dialog-content-inscription';
import { APP_ID, inject, NgModule, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule, Meta } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material-module';
import { FooterComponent } from './footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { DashboardComponent } from './componenets/dashboard/dashboard.component';
import { DatePipe } from '@angular/common';
import { PromotionCodeComponent } from './componenets/dashboard/promotion-code/promotion-code.component';
import { HeaderStickyComponent } from './componenets/header-sticky/header-sticky.component';
import { LegalNoticeComponent } from './componenets/legal-notice/legal-notice.component';
import { AboutComponent } from './componenets/about/about.component';
import { AdvertisersComponent } from './componenets/advertisers/advertisers.component';
import { CookiesPolicyComponent } from './componenets/cookies-policy/cookies-policy.component';
import { PrivacyPolicyComponent } from './componenets/privacy-policy/privacy-policy.component';
import { ContactComponent } from './componenets/contact-ngrx/contact/contact.component';
import { CookieService } from './services/cookie.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { HeaderStickyFrontOfficeComponent } from './componenets/header-sticky/header-sticky-front-office/header-sticky-front-office.component';
import { NotificationsBellComponent } from './componenets/notifications-bell/notifications-bell.component';
import { ChatButtonComponent } from './componenets/chat-button/chat-button.component';
import { MessagesComponent } from './componenets/messages/messages.component';
import { CallComponent } from './componenets/call/call.component';
import { PublicHomeComponent } from './componenets/public-home/public-home.component';
import { NavBarFooterStikyComponent } from './footer/nav-bar-footer-stiky/nav-bar-footer-stiky.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { GeneralPolicyComponent } from './componenets/general-policy/general-policy.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ProductByAdvertiserComponent } from './componenets/producs-ngrx/product-by-advertiser/product-by-advertiser.component';
import { MatExpansionModule} from '@angular/material/expansion';
import { MatDividerModule} from '@angular/material/divider';
import { CookieDialogComponent } from './componenets/cookie-dialog/cookie-dialog.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatDialogModule} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DialogContentExampleDialog } from './componenets/cookie-dialog/dialog-content/dialog-content-example-dialog';
import { ProductDetailsNgrxComponent } from './componenets/producs-ngrx/product-details-ngrx/product-details-ngrx.component';
import { NavBarFooterMobileComponent } from './footer/nav-bar-footer-mobile/nav-bar-footer-mobile.component';
import { MenuMobileComponent } from './footer/menu-mobile/menu-mobile.component';
import {MatChipsModule} from '@angular/material/chips';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { productsReducer } from './ngrx/products.reducer';
import { ProductsEffects } from './ngrx/products.effects';
import { advertisersReducer } from './ngrx/advertiser/advertisers.reducer';
import { AdvertisersEffects } from './ngrx/advertiser/advertisers.effects';
import { contactsReducer } from './ngrx/contact/contacts.reducer';
import { ContactsEffects } from './ngrx/contact/contacts.effects';
import { settingsReducer } from './ngrx/setting/settings.reducer';
import { SettingsEffects } from './ngrx/setting/settings.effects';
import { newslettersReducer } from './ngrx/newsletter/newsletter.reducer';
import { NewslettersEffects } from './ngrx/newsletter/newsletter.effects';
import { A11yModule } from '@angular/cdk/a11y';
import { PromptComponent } from './componenets/prompt/prompt.component';
import { MatCardModule } from '@angular/material/card';
import { DialogContentNewsLetter } from './componenets/newsletter-dialog/dialog-content-newsletter';
import { DialogContentLogin } from './componenets/header-sticky/login-dialog/dialog-content-login';
import { VerifyEmailComponent } from './componenets/verify-email/verify-email.component';
import { NewsletterConfirmComponent } from './componenets/newsletter-pages/newsletter-confirm.component';
import { NewsletterUnsubscribeComponent } from './componenets/newsletter-pages/newsletter-unsubscribe.component';
import { ResetPasswordComponent } from './componenets/reset-password/reset-password.component';
import { DialogContentForgotPassword } from './componenets/header-sticky/forgot-password-dialog/dialog-content-forgot-password';
import { HotDealsSidebarComponent } from './componenets/hot-deals-sidebar/hot-deals-sidebar.component';
import { ExternalSearchResultsComponent } from './componenets/external-search-results/external-search-results.component';
import { PostDealBannerComponent } from './componenets/post-deal-banner/post-deal-banner.component';
import { NearbyPanelComponent } from './componenets/nearby-panel/nearby-panel.component';
import { SidebarAdComponent } from './componenets/sidebar-ad/sidebar-ad.component';
import { PartnersSidebarComponent } from './componenets/partners-sidebar/partners-sidebar.component';
import { TechNewsSidebarComponent } from './componenets/tech-news-sidebar/tech-news-sidebar.component';
import { SettingsComponent } from './componenets/settings/settings.component';
import { MyAccountComponent } from './componenets/my-account/my-account.component';
import { SavedDealsComponent } from './componenets/my-account/saved-deals/saved-deals.component';
import { ContributionsComponent } from './componenets/my-account/contributions/contributions.component';
import { PointsClubComponent } from './componenets/my-account/points-club/points-club.component';
import { RewardsShopComponent } from './componenets/my-account/rewards-shop/rewards-shop.component';
import { UserStatsComponent } from './componenets/my-account/user-stats/user-stats.component';
import { UserBadgesComponent } from './componenets/my-account/user-badges/user-badges.component';
import { UserExpertiseComponent } from './componenets/my-account/user-expertise/user-expertise.component';
import { PostDealComponent } from './componenets/post-deal/post-deal.component';
import { DialogContentNewsLetterDisable } from './componenets/newsletter-dialog-disable/dialog-content-newsletter-disable';
import { jwtInterceptorProvider } from './shared/interceptors/jwt.interceptor';
import { errorInterceptorProvider } from './shared/interceptors/error.interceptor';
import { TranslatePipe } from './shared/pipes/translate.pipe';
import { ImgFallbackDirective } from './shared/img-fallback.directive';
import { BrandMarkComponent } from './shared/brand-mark/brand-mark.component';
import { PasswordToggleDirective } from './shared/password-toggle.directive';
import { I18nService } from './services/i18n.service';
import { ThemeService } from './services/theme.service';
//const initializer = (pwaService: PwaService) => () => pwaService.initPwaPrompt();

@NgModule({ declarations: [
        AppComponent,
        ImgFallbackDirective,
        PasswordToggleDirective,
        BrandMarkComponent,
        FooterComponent,
        DashboardComponent,
        ProductDetailsNgrxComponent,
        ProductByAdvertiserComponent,
        PromotionCodeComponent,
        HeaderStickyComponent,
        ContactComponent,
        LegalNoticeComponent,
        AboutComponent,
        AdvertisersComponent,
        CookiesPolicyComponent,
        PrivacyPolicyComponent,
        HeaderStickyFrontOfficeComponent,
        NotificationsBellComponent,
        ChatButtonComponent,
        MessagesComponent,
        CallComponent,
        PublicHomeComponent,
        NavBarFooterStikyComponent,
        GeneralPolicyComponent,
        CookieDialogComponent,
        DialogContentExampleDialog,
        DialogContentNewsLetter,
        DialogContentLogin,
        DialogContentInscription,
        DialogContentNewsLetterDisable,
        NavBarFooterMobileComponent,
        MenuMobileComponent,
        PromptComponent,
        CameraCompratorComponent,
        VerifyEmailComponent,
        NewsletterConfirmComponent,
        NewsletterUnsubscribeComponent,
        ResetPasswordComponent,
        DialogContentForgotPassword,
        HotDealsSidebarComponent,
        ExternalSearchResultsComponent,
        PostDealBannerComponent,
        NearbyPanelComponent,
        SidebarAdComponent,
        PartnersSidebarComponent,
        TechNewsSidebarComponent,
        SettingsComponent,
        MyAccountComponent,
        SavedDealsComponent,
        ContributionsComponent,
        PointsClubComponent,
        RewardsShopComponent,
        UserStatsComponent,
        UserBadgesComponent,
        UserExpertiseComponent,
        PostDealComponent,
        TranslatePipe
    ],
    exports: [
        MatSlideToggleModule,
        MatChipsModule
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        //StoreModule.forRoot({ FeatureStateName : productsReducer }),
        StoreModule.forRoot({
            ProductsStateFromModule: productsReducer,
            AdvertisersStateFromModule: advertisersReducer,
            ContactsStateFromModule: contactsReducer,
            SettingsStateFromModule: settingsReducer,
            NewslettersStateFromModule: newslettersReducer,
        }),
        EffectsModule.forRoot([
            ProductsEffects,
            AdvertisersEffects,
            ContactsEffects,
            SettingsEffects,
            NewslettersEffects
        ]),
        StoreDevtoolsModule.instrument({ connectInZone: true }),
        FormsModule,
        MatGridListModule,
        NgxSkeletonLoaderModule,
        MatAutocompleteModule,
        MatExpansionModule,
        MatDividerModule,
        MatSlideToggleModule,
        MatButtonToggleModule,
        MatCardModule,
        MatDialogModule,
        MatButtonModule,
        MatChipsModule,
        A11yModule,
        // AngularFireModule.initializeApp(environment.firebase),
        // AngularFireAnalyticsModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            // Register the ServiceWorker as soon as the app is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        })], providers: [DatePipe, Meta, CookieService, jwtInterceptorProvider, errorInterceptorProvider, provideHttpClient(withXhr(), withInterceptorsFromDi()), { provide: APP_ID, useValue: 'Affliate-market' }, provideZoneChangeDetection(),
        // Charge la langue (appareil ou choix de l'utilisateur) avant le premier rendu
        provideAppInitializer(() => inject(I18nService).init()),
        // Applique le thème (automatique selon l'heure ou choix de l'utilisateur) avant le premier rendu
        provideAppInitializer(() => inject(ThemeService).init()),] })
export class AppModule {

  constructor() { }

}
